var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-page-outer-container" },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$route.name === "list-settings"
        ? _c(
            "all-lists-data-table",
            {
              attrs: {
                "pagination-from-parent": _vm.pagination,
                "search-from-parent": _vm.allListsSearch
              },
              on: {
                "update-pagination": function($event) {
                  _vm.pagination = $event
                },
                "update-search": function($event) {
                  _vm.allListsSearch = $event
                }
              }
            },
            [
              _c("management-add-button", {
                attrs: {
                  label: _vm.$t("AddCustomList"),
                  disabled: !this.userHasManagementPermission(
                    "custom_list_store"
                  ),
                  listMissingPermissions: []
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$router.push({ name: "custom-list-create" })
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-424fe930", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424fe930","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListsSettingsPage.vue
// module id = null
// module chunks = 